import * as React from 'react';

import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';

import { Pagination } from '@/react-query/context/ApiClientContextController';
import { Inquiry } from '@/services/faq/faq.types';
import { getColumns } from './Column';
import { Translation, useDynamicLocale } from '@/hoslog-intl';

export function ComplaintsTable({
  data,
  pagination,
  loading,
}: {
  data: Inquiry[];
  pagination: Pagination;
  loading: boolean;
}) {
  const { t } = useDynamicLocale();
  const columns = React.useMemo(() => getColumns(t), [t]);
  const pageCount = React.useMemo(
    () => Math.ceil((pagination.totalItems ?? 0) / (pagination.pageSize ?? 1)),
    [pagination.totalItems, pagination.pageSize],
  );

  const { table } = useDataTable({
    data: data,
    columns,
    pageCount: pageCount,
    initialState: {
      sorting: [{ id: 'sn', desc: true }],
    },
    meta: {
      title: <Translation id="faq.complaints.table.title" />,
      totalPage: pagination.totalItems,
      loading: loading,
    },
    getRowId: (originalRow) => String(originalRow.sn),
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <>
      <DataTable table={table} className="font-medium">
        <DataTableToolbar />
      </DataTable>
    </>
  );
}
